import React from 'react'
import './RecentActivity.css'
import RecentActivityItem from './RecentActivityItem'
import { Link } from 'react-router-dom'


function RecentActivity({ sectionTitle, pathUrl, time }) {
    return (
        <div className="MarketMove">
            <h2 className="sectionHeading">{ sectionTitle }</h2>
            <div className="MarketMoveItems">
               <RecentActivityItem
                    username = "@username"
                    assetTitle = "Wake me up"
                    paraText = "created"
                    time = "1 Hours ago"
                    usernameURl = "/user/username"
                    assetURL = "/user/username/asset"
                    userThumb = "https://ipfs.pixura.io/ipfs/QmYGcxQKP8jX67cLN4Rcgyb62HVuSV23S1TVKHXrNMB4xk/1Y8A8366%20copy.JPG"
                    activityThumb = "https://ipfs.pixura.io/ipfs/QmUX7hspEDFqbn2QBXLuXZJtFfiRhzkFQEyJrhEWCiZcRE/w-a-k-e-m-e-u-p-.jpg"
               />
               <RecentActivityItem
                    username = "@username"
                    assetTitle = "Grandeur"
                    paraText = "created"
                    time = "3 Hours ago"
                    usernameURl = "/user/username"
                    assetURL = "/user/username/asset"
                    userThumb = "https://ipfs.pixura.io/ipfs/QmYGcxQKP8jX67cLN4Rcgyb62HVuSV23S1TVKHXrNMB4xk/1Y8A8366%20copy.JPG"
                    activityThumb = "https://ipfs.pixura.io/ipfs/QmTfnH6DTeTzsgWAeEt3UDLo5KzND66JFAYGLWyoNmm1KN/eta-aquariid.jpg"
               />
               <RecentActivityItem
                    username = "@username"
                    assetTitle = "Eta Aquariid"
                    paraText = "created"
                    time = "5 Hours ago"
                    usernameURl = "/user/username"
                    assetURL = "/user/username/asset"
                    userThumb = "https://ipfs.pixura.io/ipfs/QmYGcxQKP8jX67cLN4Rcgyb62HVuSV23S1TVKHXrNMB4xk/1Y8A8366%20copy.JPG"
                    activityThumb = "https://ipfs.pixura.io/ipfs/QmXyzPm6k85QJHoxJAxPVeH3JhV4a49RsBJMaXMNLWtjRX/grandeur.jpg"
               />
            </div>
            <div className="fullarea">
                <Link to={ pathUrl } className="btnSeeAll">See All Activity</Link>
            </div>
        </div>
    )
}

export default RecentActivity
